<template>
  <v-row
    no-gutters
    class="justify-end"
    style="align-items: center;"
  >
    <div class="price" @click="toggleEditPrice" v-if="!editPrice">
      {{tariff.price}} &#8376;
    </div>
    <input
      type="text"
      class="priceInput"
      v-if="editPrice"
      ref="inpt"
      :placeholder="tariff.price"
      v-model="newPrice"
    >
    <div
      class="create-block-btn mr-1"
      v-if="editPrice"
      @click="updateTariff({
        id:tariff.id,
        title:tariff.title,
        color:tariff.color,
        price:newPrice
      })"
    >
      <img src="@/assets/images/Active.svg" alt="">
    </div>
    <div
      class="cancel-block-btn"
      style="cursor: pointer;"
      v-if="editPrice"
      @click="toggleEditPrice"
    >
      <img src="@/assets/images/cancel-btn.svg" alt="">
    </div>
  </v-row>
</template>

<script>
export default {
  name: "EditFinance",
  data() {
    return {
      editPrice:false,
      newPrice:null,
    };
  },
  props:{
    tariff:{
      type: Object,
      default: ()=>{},
    }
  },
  methods:{
    toggleEditPrice(){
      this.editPrice=!this.editPrice;
      if (this.editPrice){
        this.$nextTick(() => this.$refs.inpt.focus());
      }
      else{
        this.newPrice=null;
      }
    },

    updateTariff(data){
      this.$emit('update',data);
      this.toggleEditPrice();
      this.newPrice=null;
    }
  }
}

</script>

<style scoped>

</style>